import styled from 'styled-components' // -> /macro for debug purposes

export const AppLayout = styled.div`
  width: 100%;
  min-height: 100vh;
  height: 100vh;
`